import NetworksSection from './NetworksSection';
import { connect } from 'react-redux';
import { structuredNetworksSelector } from 'state/Podcast/selectors';

export default connect(structuredNetworksSelector)(NetworksSection);
